module.exports = __webpack_public_path__ + "static/img_pledge_children_02M@2x-a41eed60caa63379838c22989bf7272a.png";